import { AbstractEntity } from "../../AbstractEntity";
import Protocol from "../../protocol/Protocol";
import { getUtcNow } from "../../../utils";
export default class NoonReportDispatch extends AbstractEntity {
    createdTimestamp;
    noonReport;
    author;
    dispatchedBy;
    timestamp;
    constructor(noonReportDispatch) {
        super();
        Object.assign(this, { createdTimestamp: getUtcNow() }, noonReportDispatch);
    }
}
//# sourceMappingURL=NoonReportDispatch.js.map